import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import FormComponent from 'modules/core/components/Form'
import FormRow from 'modules/core/components/FormRow'
import Text from 'modules/core/components/Inputs/Text'
import PanesHeader from 'modules/core/components/PanesHeader'
import PanesPadForm from 'modules/core/components/PanesPadForm'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import { employeeLegalEntity } from 'modules/core/lib/employeeLegalEntity'
import { formGetDirtyFields } from 'modules/core/lib/formGetDirtyFields'
import i18n from 'modules/core/lib/i18n'
import { employeeUser } from 'modules/core/store/collections/users'

import {
  FormTypes,
  useEmployeePersonalProvider,
} from 'modules/employees/components/blocks/EmployeePersonalProvider'
import type Employee from 'modules/employees/store/models/Employee'

interface Props {
  employee: Employee
  readonly: boolean
}

export const ContactBlock = observer((props: Props) => {
  const { employee, readonly } = props
  const { addEmergencyContact, addEmergencyPhoneNumber } = trackingEvents.employee.personal
  const {
    contactForm,
    onSubmit: onSubmitContact,
    disableSectionSaveButtons,
  } = useEmployeePersonalProvider()
  const legalEntity = employeeLegalEntity(employee)

  const onSubmit = () => {
    track(trackingEvents.employee.editEmployeeInformationSubmit, {
      fields_edited: formGetDirtyFields(contactForm),
      legal_entity_country: legalEntity.country,
      layout_version: 'v1',
    })
    onSubmitContact([FormTypes.CONTACT])
  }

  return (
    <FormComponent onSubmit={onSubmit}>
      <FormRow>
        <Text
          label={i18n.t('employee_form.contact_name')}
          field={contactForm.get('contact_name')}
          readonly={readonly}
          onBlur={() => track(addEmergencyContact)}
        />
      </FormRow>

      <FormRow>
        <Text
          label={i18n.t('employee_form.contact_number')}
          field={contactForm.get('contact_number')}
          readonly={readonly}
          onBlur={() => track(addEmergencyPhoneNumber)}
        />
      </FormRow>

      {!disableSectionSaveButtons && contactForm.isDirty && (
        <FormRow footer>
          <Button submit>{i18n.t('common.submit')}</Button>
        </FormRow>
      )}
    </FormComponent>
  )
})

const Contact = (props: Props) => {
  return (
    <PanesPadForm direction="horizontal" boxed>
      <PanesHeader
        illustration="user-health"
        title={i18n.t('employee_form.emergency_contact.title')}
        description={i18n.tCurrent(
          'employee_form.emergency_contact.description',
          employeeUser(props.employee).isCurrent()
        )}
      />
      <ContactBlock {...props} />
    </PanesPadForm>
  )
}

export default observer(Contact)
